import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
        <path
            fill={props.fill ?? 'currentColor'}
            d="M3.6 13.6c-.33 0-.613-.12-.848-.358A1.161 1.161 0 0 1 2.4 12.4V3.6c0-.322.117-.603.352-.842S3.27 2.4 3.6 2.4h5.2v1.2H3.6v8.8h8.8V8h1.2v4.4c0 .322-.118.603-.353.842a1.146 1.146 0 0 1-.847.358H3.6Zm.8-2.4h7.2L9.2 8l-1.8 2.4-1.2-1.6-1.8 2.4Zm7.8-4.8V3.9l-.525.525a.601.601 0 0 1-.85-.85l1.268-1.268a1 1 0 0 1 1.414 0l1.268 1.268a.601.601 0 0 1-.85.85L13.4 3.9v2.5h-1.2Z"
        />
    </svg>
);
export { SvgComponent as ImageArrowUp };
